{
	"type": "line",
	"minzoom": 6,
	"layout": {
		"line-join": "round",
		"line-cap": "butt"
	},
	"paint": {
		"line-color": [
			"match",
			["get", "curve_context"],
			"Class 1",
			"#ED2938",
			"Class 2",
			"#FFAA1C",
			"Class 3",
			"#41C300",
			"Class 4",
			"#aaa",
			"#ddd"
		],
		"line-offset": [
			"interpolate",
			["linear"],
			["zoom"],
			0,
			0,
			9,
			0,
			18,
			["match", ["get", "visual_offset"], "Right", 16, "Left", -16, 0]
		],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 1, 18, 8],
		"line-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 1, 0], 11, 1],
		"line-dasharray": ["match", ["get", "road_seal"], 1, ["literal", [1, 0]], ["literal", [0.8, 1]]]
	}
}
